import React, { Component } from 'react';
import { Card, Nav } from 'react-bootstrap';
import {Link } from 'react-router-dom';
import Paypal from './dashboard/Paypal';

class Footer extends Component {
    render() {
        return (
            <div>
                <Card className="text-center bg-light text-black" border="light">
                    {/* <Card.Body>
                        <Card.Text>
                            <small className="text-muted">Copyrights Financial Market Visualization</small>
                        </Card.Text>
                        <Card.Text>
                            <small className="text-muted">Quotes are delayed 15 mins for all Stocks.</small>
                            <Link to={"/privacy"} Privacy Policy></Link>
                        </Card.Text>
                    </Card.Body> */}
                    <Card.Footer className="text-muted">
                        <small className="text-muted">Copyrights Financial Market Visualization</small>
                        <div></div>
                        <small className="text-muted">Quotes are realtime for all Stocks/Futures Chart Page</small>
                        <Nav className="justify-content-center">
                            {/* <Nav.Link href="/privacy">Privacy Policy</Nav.Link>
                            <Nav.Link href="/contact">Contact</Nav.Link> */}

                            <Link className="nav-link" to="/privacy">Privacy Policy</Link>
                            <Link className="nav-link" to="/contact">Contact</Link>   
                            <Paypal />                         
                        </Nav>

                    </Card.Footer>
                </Card>
            </div>
        );
    }
}

export default Footer;
